export default __webpack_public_path__ + "static/media/peprew.ea76c229.jpg";